module.exports = __webpack_public_path__ + "img/loading.c12ace2d.svg";